enum CustomerSortType {
  NONE = "NONE",
  NUMBER_ASC = "NUMBER_ASC",
  NUMBER_DESC = "NUMBER_DESC",
  NAME_ASC = "NAME_ASC",
  NAME_DESC = "NAME_DESC",
  CREATED_ASC = "CREATED_ASC",
  CREATED_DESC = "CREATED_DESC",
  UPDATED_ASC = "UPDATED_ASC",
  UPDATED_DESC = "UPDATED_DESC",
}

export default CustomerSortType;
